// React
import React from "react";
// Routing
import * as AppRouting from "appRouting";
// Components
import SideBar_Link from "app/application/ui/sideBars/SideBar_Link";
import SideBar_Category from "app/application/ui/sideBars/SideBar_Category";
// Helpers
import NamingHelper from "common/utils/namingHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./SideBar.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class Category_AgencyReports extends React.Component {
    render() {
        let { agencyId, currentUrl } = this.props;
        if (!this.props.agencyId) {
            return React.createElement("div", null);
        }
        return (React.createElement(SideBar_Category, { text: NamingHelper.reports, isExpanded: this.props.isExpanded, headingStyle: styles.linkStyleReports, headingIcon: "fa fa-bar-chart", url: AppRouting.agencyReportsUrl(agencyId), currentUrl: currentUrl },
            React.createElement(SideBar_Link, { text: NamingHelper.agencyOverview, url: AppRouting.agencyStatsReportUrl(agencyId) })));
    }
}
